<script lang="ts">
    import { language } from "../../store"
</script>

<div class="container">
    <img alt="bg-img" class="img" src="/media/hp-bg.jpeg" />
    <div class="text-container">
        <div class="main">{$language == "german" ? "WILLKOMMEN BEI" : "WELCOME TO"}</div>
        <div class="main">H+H SENIOR ADVISORS GMBH</div>
        <h2 class="add">
            {$language == "german"
                ? "Eine Gruppe von Beratern für Familienunternehmensstrategie."
                : "A group of Advisors on Family Business Strategy."}
        </h2>
    </div>
</div>

<style lang="less">
    @import "../assets/css/variables.less";
    .container {
        width: 100%;
        height: min(70vh, 560px);
        position: relative;

        display: flex;
        justify-content: center;
        align-items: flex-end;
        .text-container {
            margin-bottom: 88px;
            width: 100%;
            max-width: @max-width;
            @media @mobile {
                padding: 0px calc(@default-padding / 1.5);
            }
            @media @tablet {
                padding: 0px @default-padding;
            }
            display: flex;
            flex-direction: column;
            gap: 10px;
            @media @mobile {
                .main,
                .add {
                    width: fit-content;
                    padding: 7px 15px;
                }
                .main {
                    font-size: 1.65rem;
                    background-color: white;
                }
                .add {
                    background-color: @main-dark;
                    color: white;
                }
            }
            @media @tablet {
                .main,
                .add {
                    width: fit-content;
                    padding: 15px 30px;
                }
                .main {
                    font-size: 2.2rem;
                    background-color: white;
                }
                .add {
                    background-color: @main-dark;
                    color: white;
                }
            }
        }
        .img {
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center center;
        }
    }
</style>
